/* Albindress — facets.js
   Filtri nativi Shopify (Storefront Filtering), ordinamento e paginazione
   aggiornati senza ricaricare la pagina. Senza JavaScript il modulo funziona
   con invio standard. */
(function () {
  'use strict';

  const SG = (window.Albin = window.Albin || {});
  if (customElements.get('facet-filters')) return;

  customElements.define(
    'facet-filters',
    class FacetFilters extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.abortController = null;
        this.onChange = SG.debounce((event) => this.submit(event), 400);

        this.addEventListener('change', (event) => {
          if (event.target.closest('form[data-facets-form]')) this.onChange(event);
        });
        this.addEventListener('submit', (event) => {
          const form = event.target.closest('form[data-facets-form]');
          if (!form) return;
          event.preventDefault();
          this.submit(event);
        });
        this.addEventListener('click', (event) => {
          const link = event.target.closest('a[data-facet-link]');
          if (!link) return;
          event.preventDefault();
          const url = new URL(link.href, window.location.origin);
          this.load(url.searchParams.toString(), null);
        });
        window.addEventListener('popstate', (event) => {
          const params = (event.state && event.state.facets) || window.location.search.slice(1);
          this.load(params, null, false);
        });
      }

      buildParams() {
        const params = new URLSearchParams();
        this.querySelectorAll('form[data-facets-form]').forEach((form) => {
          new FormData(form).forEach((value, key) => {
            if (value === '' || value === null) return;
            if (!params.getAll(key).includes(String(value))) params.append(key, value);
          });
        });
        params.delete('page');
        return params.toString();
      }

      submit(event) {
        const focusId = event && event.target && event.target.id ? event.target.id : null;
        this.load(this.buildParams(), focusId);
      }

      async load(params, focusId, push) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();
        const results = this.querySelector('[data-facets-results]');
        if (results) results.setAttribute('aria-busy', 'true');
        const url = window.location.pathname + '?' + (params ? params + '&' : '') + 'section_id=' + encodeURIComponent(this.sectionId);
        try {
          const response = await fetch(url, { signal: this.abortController.signal });
          if (!response.ok) throw new Error(String(response.status));
          const doc = SG.parseHTML(await response.text());
          ['[data-facets-results]', '[data-facets-sidebar]', '[data-facets-active]', '[data-facets-count]'].forEach((selector) => {
            const from = doc.querySelector(selector);
            const to = this.querySelector(selector);
            if (from && to) to.innerHTML = from.innerHTML;
          });
          // Mantiene aperti i gruppi di filtri già aperti dall'utente
          this.querySelectorAll('details[data-open-desktop]').forEach((el) => {
            if (window.matchMedia('(min-width: 990px)').matches) el.setAttribute('open', '');
          });
          if (push !== false) {
            const newUrl = window.location.pathname + (params ? '?' + params : '');
            window.history.pushState({ facets: params }, '', newUrl);
          }
          const count = this.querySelector('[data-facets-count]');
          SG.announce(count ? count.textContent.trim() : SG.strings.resultsUpdated);
          if (focusId) {
            const el = document.getElementById(focusId);
            if (el) el.focus({ preventScroll: true });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.href = window.location.pathname + (params ? '?' + params : '');
        } finally {
          const updated = this.querySelector('[data-facets-results]');
          if (updated) updated.setAttribute('aria-busy', 'false');
        }
      }
    }
  );
})();
